import type { ReactNode } from 'react';

interface PageShellProps {
  title: ReactNode;
  headerAside?: ReactNode;
  // Optional sub-header rendered inside the navbar's dark background area
  // BELOW the main title row. Used by App.tsx to drop the mobile admin
  // menu in here so the menu panel's full-width layout doesn't fight with
  // the flex-wrap + items-center alignment of the title row.
  subHeader?: ReactNode;
  children: ReactNode;
}

export function PageShell({ title, headerAside, subHeader, children }: PageShellProps): JSX.Element {
  return (
    <main className="min-h-full bg-brand-white">
      <div className="bg-brand-charcoal text-brand-white">
        <header className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center gap-2">{title}</div>
          {headerAside ? (
            <div className="flex flex-wrap items-center gap-2">{headerAside}</div>
          ) : null}
        </header>
        {subHeader ? (
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{subHeader}</div>
        ) : null}
      </div>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{children}</div>
    </main>
  );
}
